import { getAppLangSegment } from './app-lang-segment';
import type {
  AppLangLinkInput,
  GameProviderRoute,
  GameRoute,
  PromotionsRoute,
  StaticLangLink,
  UserSettingsRoute
} from './types';

// Function overloads for better type safety and IntelliSense
// All routes MUST end with slash!
export function appLangLink(link: '/'): string;
export function appLangLink(link: `/${StaticLangLink}/`): string;
export function appLangLink(link: `/${GameProviderRoute}/`): string;
export function appLangLink(link: `/${PromotionsRoute}/`): string;
export function appLangLink(link: `/${GameRoute}/`): string;
export function appLangLink(link: `/${UserSettingsRoute}/`): string;
export function appLangLink(link: AppLangLinkInput): string;

export function appLangLink(link: AppLangLinkInput): string {
  const lang: string = getAppLangSegment() ?? 'en';

  // Link already validated by TypeScript to have correct format
  return `/${lang}${link}`;
}

export function appLangLinkUntyped(link: string): string {
  const lang: string = getAppLangSegment() ?? 'en';
  return `/${lang}${link}`;
}
